<div class="row gx-2 gx-md-3 justify-content-between align-items-center">
  <div class="col-auto">
    <mwe-button
      [size]="buttonSize()"
      (clicked)="backwardClicked.emit()"
      [title]="hoverBackLabelKey()"
      category="primary"
      color="blue"
      [isIconBtn]="true"
      [disabled]="!isBackwardButtonAvailable()"
    >
      <i class="fas fa-angle-left" aria-hidden="true"></i>
    </mwe-button>
  </div>
  <div class="col-auto">
    <h2 [ngClass]="titleClass()">{{ navTitle() }}</h2>
  </div>
  <div class="col-auto">
    <mwe-button
      [size]="buttonSize()"
      (clicked)="forwardClicked.emit()"
      [title]="hoverForwardLabelKey()"
      category="primary"
      color="blue"
      [isIconBtn]="true"
      [disabled]="!isForwardButtonAvailable()"
    >
      <i class="fas fa-angle-right" aria-hidden="true"></i>
    </mwe-button>
  </div>
</div>
